import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/EkedEquipmentActions";
import * as api from "../../api/EkedEquipmentApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { getFilesFromZip } from "../../common";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";

function* getEkedEquipments(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getEkedEquipments(action.payload);
        yield put(actions.setEkedEquipments(data || undefined));
    } catch (error) {
        yield put(actions.setEkedEquipments(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addEkedEquipment(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addEkedEquipment(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateEkedEquipment(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateEkedEquipment(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteEkedEquipment(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteEkedEquipment(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEkedEquipmentFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getEkedEquipmentFiles(action.payload);
        const files = yield getFilesFromZip(data);
        yield put(actions.setEkedEquipmentFiles(files || undefined));
    } catch (error) {
        yield put(actions.setEkedEquipmentFiles(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addEkedEquipmentFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.addEkedEquipmentFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteEkedEquipmentFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deleteEkedEquipmentFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEkedEquipmentFilePreviews(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getEkedEquipmentFilePreviews(action.payload);
        const files = yield getFilesFromZip(data);
        yield put(actions.setEkedEquipmentFilePreviews(files || undefined));
    } catch (error) {
        yield put(actions.setEkedEquipmentFilePreviews(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}


function* watchAll() {
    yield takeEvery(actions.Types.GET_EKEDEQUIPMENTS, getEkedEquipments);
    yield takeEvery(actions.Types.ADD_EKEDEQUIPMENT, addEkedEquipment);
    yield takeEvery(actions.Types.UPDATE_EKEDEQUIPMENT, updateEkedEquipment);
    yield takeEvery(actions.Types.DELETE_EKEDEQUIPMENT, deleteEkedEquipment);
    yield takeEvery(actions.Types.GET_EKED_EQUIPMENT_FILES, getEkedEquipmentFiles);
    yield takeEvery(actions.Types.ADD_EKED_EQUIPMENT_FILES, addEkedEquipmentFiles);
    yield takeEvery(actions.Types.DELETE_EKED_EQUIPMENT_FILES, deleteEkedEquipmentFiles);
    yield takeEvery(actions.Types.GET_EKED_EQUIPMENT_FILE_PREVIEWS, getEkedEquipmentFilePreviews);
}


const EkedEquipmentSaga = [fork(watchAll)];

export default EkedEquipmentSaga;
